import React from 'react'
import styled from 'styled-components'

import { Footer, Navbar } from './shared'
import { IOSAppAlert } from './shared/iOSAppAlert'
import { CookieConsent } from './shared/CookieConsent'
import { useLocation } from 'react-router-dom'

export const DefaultLayout = ({ children, className, withMargins = true }) => {
  const location = useLocation()

  const showIOSAppAlert =
    location.pathname === '/' || location.pathname === '/homepage'

  return (
    <Root className={className}>
      {showIOSAppAlert && <IOSAppAlert />}
      <Navbar />
      {withMargins && <Body>{children}</Body>}
      {!withMargins && <>{children}</>}
      <Footer />
      <CookieConsent />
    </Root>
  )
}

const Root = styled.div``

const Body = styled.div`
  padding: 40px 0;
  height: 100%;

  @media (max-width: 991px) {
    padding: 20px 0;
  }

  @media (max-width: 639px) {
    padding: 10px 0;
  }
`
